<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogoExportar" persistent :max-width="Modal.Confirmacao.larguraMaxima">
            <v-list-tile-title slot="activator">
                <i class="fas fa-file-export mr-2" aria-hidden="true"/>
                Exportar - <strong>Mais Brasil</strong>
            </v-list-tile-title>

            <v-card v-if="mostrarDialogoExportar" :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
                <v-card-title class="primary modal-title" primary-title>
                    <span>Exportar +Brasil</span>
                </v-card-title>

                <v-card-text>
                    <h4 class="mb-1 grey--text text--darken-1">
                        Deseja realmente enviar o processo com a seguinte situação?
                    </h4>

                    <v-radio-group name="Situação"
                                   v-model="situacaoSelecionada"
                                   v-validate="'required'"
                                   key="Situação do Envio"
                                   :error-messages="errors.collect('Situação')">
                        <v-radio label="Em Andamento" value="EM_ANDAMENTO" color="primary"></v-radio>
                        <v-radio label="Concluído" value="CONCLUIDO" color="primary"></v-radio>
                    </v-radio-group>
                </v-card-text>

                <v-card-actions class="px-3 py-2">
                    <v-btn  @click="mostrarDialogoExportar = false" flat outline color="botao-cancelar-color">
                        NÃO
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="exportarMaisBrasil" color="primary" depressed>
                        SIM
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'AcoesExportarMaisBrasil',
    data() {
        return {
            mostrarDialogoExportar: false,
            situacaoSelecionada: null,
            Modal
        }
    },
    methods: {
        async exportarMaisBrasil() {
            const estaValidado = await this.$validator.validate('Situação')
            if (!estaValidado) {
                throw new Error('Preencha o campo situação')
            }

            this.mostrarDialogoExportar = false
            this.$emit('exportarMaisBrasil', this.situacaoSelecionada)
        }
    }
}
</script>

<style scoped lang="stylus">
.v-dialog__container
    width 100%

.mensagem-confirmacao
    &__texto
        text-align center
        color #777

    &__texto-secundario
        width 80%
        margin 0 auto

    &__acao
        text-align center
        margin-bottom 16px

        .botao
            color #777 !important
            border 0

        .botao:first-child
            margin-right 10px

        .botao-primario, .botao
            text-transform uppercase
            font-size 13px

        .botao-primario
            background-color var(--v-primary-base) !important
            color #fff !important
            border 1px solid var(--v-primary-base)
</style>
